import { render, staticRenderFns } from "./TipsBlock.vue?vue&type=template&id=4376d3d1"
import script from "./TipsBlock.vue?vue&type=script&lang=js"
export * from "./TipsBlock.vue?vue&type=script&lang=js"
import style0 from "./TipsBlock.vue?vue&type=style&index=0&id=4376d3d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports